var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"nav"},_vm._l((_vm.steps),function(step,s){return _c('li',{staticClass:"nav-item"},[_c('span',{staticClass:"button d-flex align-items-center justify-content-center",class:s >= _vm.currentStep ? 'button-default' : 'button-primary'},[_vm._v(_vm._s(step))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }